export default __webpack_public_path__ + "static/media/icons-activity-log.f7eceb84.svg";